<template>
  <head>
    <meta charset="utf-8" />
    <title>HOSPITAL MANAGEMENT INFORMATION SYSTEM</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="HMIS By Craft Silicon Payments" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />

    <!-- owl.carousel css -->
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Employment Types</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="#">Organization Structure</a></li>
                    <li class="breadcrumb-item"><a href="#">Employment Types</a></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <h4 class="card-title text-uppercase mb-0">
                      All Available Employment Types
                    </h4>

                    <div class="d-flex">
                      <button
                          @click="showCreateModal = true"
                          type="button"
                          class="btn btn-primary waves-effect btn-label waves-light text-uppercase"
                          v-if="hasPermission('manage_employment_types')"
                      >
                        <i class="bx bx-plus label-icon"></i> New Employment Type
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-header bg-white border-bottom py-3">
                  <div class="btn-toolbar d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input
                              type="text"
                              v-model="filters.searchTerm"
                              @input="debounceSearch"
                              class="form-control bg-light border-light rounded"
                              placeholder="Search..."
                              spellcheck="false"
                          >
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex">
                      <div class="d-flex align-items-center">
                        <div class="d-flex justify-content-between">
                          <div class="float-end d-flex">
                            <div class="input-group fw-semibold text-uppercase me-3">
                              <label class="input-group-text text-uppercase">Status</label>
                              <select v-model="filters.status" @change="fetchEmploymentTypes" class="form-select">
                                <option value="">All Statuses</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                              </select>
                            </div>

                            <div class="input-group fw-semibold text-uppercase" title="Select the starting date to filter records based on the last edit date.">
                              <label class="input-group-text text-uppercase">From:</label>
                              <input
                                  v-model="filters.startDate"
                                  @change="fetchEmploymentTypes"
                                  class="form-control form-control-sm"
                                  type="date"
                              >
                            </div>

                            <div class="input-group fw-semibold text-uppercase" title="Select the ending date to filter records based on the last edit date.">
                              <label class="input-group-text text-uppercase">To:</label>
                              <input
                                  v-model="filters.endDate"
                                  @change="fetchEmploymentTypes"
                                  class="form-control form-control-sm"
                                  type="date"
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-2">Loading employment types...</p>
                  </div>

                  <!-- Error State -->
                  <div v-else-if="error" class="alert alert-danger" role="alert">
                    <i class="mdi mdi-alert-circle-outline me-2"></i>
                    {{ error }}
                    <button @click="fetchEmploymentTypes" class="btn btn-sm btn-danger float-end">
                      <i class="mdi mdi-refresh"></i> Retry
                    </button>
                  </div>

                  <!-- Data Table -->
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover contacts-table text-uppercase border">
                      <thead class="table-light">
                      <tr>
                        <th scope="col">SN</th>
                        <th scope="col">Employment Type</th>
                        <th scope="col">Abbreviation</th>
                        <th scope="col">Employees Count</th>
                        <th scope="col">Status</th>
                        <th>Last Updated</th>
                        <th class="text-right">Actions</th>
                      </tr>
                      </thead>
                      <tbody class="border">
                      <tr v-if="employmentTypes.length === 0">
                        <td colspan="7" class="text-center py-4">
                          <i class="mdi mdi-information-outline"></i> No employment types found
                        </td>
                      </tr>
                      <tr v-for="(type, index) in employmentTypes" :key="type.employment_type_id">
                        <td>{{ (currentPage - 1) * limit + index + 1 }}.</td>
                        <td>{{ type.employment_type_name }}</td>
                        <td>{{ type.abbreviation || '-' }}</td>
                        <td>{{ type.employee_count || 0 }}</td>
                        <td class="fw-bold text-black">
                          <p class="mb-2 text-truncate">
                            <i :class="type.status === 'active' ? 'mdi mdi-circle text-success' : 'mdi mdi-circle text-danger'" class="me-1"></i>
                            {{ type.status === 'active' ? 'Active' : 'Inactive' }}
                          </p>
                        </td>
                        <td>{{ formatDate(type.updated_at) }}</td>
                        <td class="text-uppercase text-right">
                          <div class="d-flex justify-content-end">
                            <button
                                @click="editEmploymentType(type)"
                                class="btn btn-sm btn-success text-uppercase"
                                title="Edit Employment Type"
                                v-if="hasPermission('manage_employment_types')"
                            >
                              Edit
                            </button>
                            <button
                                @click="showEmploymentTypeDetails(type)"
                                class="btn btn-sm btn-info text-uppercase mx-2"
                                title="View Employment Type Details"
                            >
                              Details
                            </button>
                            <button
                                v-if="type.status === 'active' && hasPermission('manage_employment_types')"
                                @click="deactivateEmploymentType(type)"
                                class="btn btn-sm btn-danger text-uppercase d-flex align-items-center"
                                title="Deactivate Employment Type"
                                :disabled="type.isProcessing"
                            >
                              <div>Deactivate</div>
                              <div v-if="type.isProcessing" class="spinner-border text-white ms-2" style="height: 19px; width: 19px;" role="status">
                                <span class="sr-only">Loading...</span>
                              </div>
                            </button>
                            <button
                                v-else-if="type.status === 'inactive' && hasPermission('manage_employment_types')"
                                @click="activateEmploymentType(type)"
                                class="btn btn-sm btn-success text-uppercase"
                                title="Activate Employment Type"
                            >
                              Activate
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Pagination -->
                  <div v-if="totalPages > 1" class="row mt-4">
                    <div class="col-sm-12 col-md-6">
                      <div class="dataTables_info">
                        Showing {{ (currentPage - 1) * limit + 1 }} to {{ Math.min(currentPage * limit, total) }} of {{ total }} entries
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination">
                          <li class="paginate_button page-item previous" :class="{ disabled: currentPage === 1 }">
                            <a @click="changePage(currentPage - 1)" class="page-link">Previous</a>
                          </li>
                          <li v-for="page in displayedPages" :key="page" class="paginate_button page-item" :class="{ active: page === currentPage }">
                            <a @click="changePage(page)" class="page-link">{{ page }}</a>
                          </li>
                          <li class="paginate_button page-item next" :class="{ disabled: currentPage === totalPages }">
                            <a @click="changePage(currentPage + 1)" class="page-link">Next</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Create Employment Type Modal -->
      <div v-if="showCreateModal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">Create New Employment Type</h4>
              <button type="button" class="btn-close" @click="closeCreateModal"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-6 mb-3">
                  <div class="mb-3">
                    <label for="employment-type-name" class="form-label">Employment Type Name<strong class="text-danger fw-bold">*</strong></label>
                    <input
                        type="text"
                        v-model="formData.employmentTypeName"
                        class="form-control"
                        id="employment-type-name"
                        placeholder="Enter Employment Type Name"
                        spellcheck="false"
                        required
                    >
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div class="mb-3">
                    <label for="employment-type-abbreviation" class="form-label">Abbreviation</label>
                    <input
                        type="text"
                        v-model="formData.abbreviation"
                        class="form-control"
                        id="employment-type-abbreviation"
                        placeholder="Enter Abbreviation (e.g., FT)"
                        spellcheck="false"
                        maxlength="20"
                    >
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div class="mb-3">
                    <label for="employment-type-status" class="form-label">Status<strong class="text-danger fw-bold">*</strong></label>
                    <select v-model="formData.status" id="employment-type-status" class="form-select" required>
                      <option disabled value="">Select Status</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                </div>

                <div class="col-12 mb-3">
                  <div class="mb-3">
                    <label for="employment-type-description" class="form-label">Description</label>
                    <textarea
                        v-model="formData.description"
                        id="employment-type-description"
                        placeholder="Enter Description"
                        class="form-control"
                        rows="3"
                        spellcheck="false"
                    ></textarea>
                  </div>
                </div>
              </div>

              <!-- Error Alert -->
              <div v-if="modalError" class="alert alert-danger" role="alert">
                <i class="mdi mdi-alert-circle-outline me-2"></i>
                {{ modalError }}
              </div>

              <!-- Success Alert -->
              <div v-if="modalSuccess" class="alert alert-success" role="alert">
                <i class="mdi mdi-check-circle-outline me-2"></i>
                {{ modalSuccess }}
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button
                    type="submit"
                    @click="createEmploymentType"
                    :disabled="processing"
                    class="btn btn-primary waves-effect waves-light"
                >
                  <span v-if="processing" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ processing ? 'Saving...' : 'Save' }}
                </button>
                <button
                    type="reset"
                    @click="closeCreateModal"
                    :disabled="processing"
                    class="btn btn-secondary waves-effect"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Edit Employment Type Modal -->
      <div v-if="showEditModal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">Edit Employment Type</h4>
              <button type="button" class="btn-close" @click="closeEditModal"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-6 mb-3">
                  <div class="mb-3">
                    <label for="edit-employment-type-name" class="form-label">Employment Type Name<strong class="text-danger fw-bold">*</strong></label>
                    <input
                        type="text"
                        v-model="editFormData.employmentTypeName"
                        class="form-control"
                        id="edit-employment-type-name"
                        placeholder="Enter Employment Type Name"
                        spellcheck="false"
                        required
                    >
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div class="mb-3">
                    <label for="edit-employment-type-abbreviation" class="form-label">Abbreviation</label>
                    <input
                        type="text"
                        v-model="editFormData.abbreviation"
                        class="form-control"
                        id="edit-employment-type-abbreviation"
                        placeholder="Enter Abbreviation (e.g., FT)"
                        spellcheck="false"
                        maxlength="20"
                    >
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div class="mb-3">
                    <label for="edit-employment-type-status" class="form-label">Status<strong class="text-danger fw-bold">*</strong></label>
                    <select v-model="editFormData.status" id="edit-employment-type-status" class="form-select" required>
                      <option disabled value="">Select Status</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                </div>

                <div class="col-12 mb-3">
                  <div class="mb-3">
                    <label for="edit-employment-type-description" class="form-label">Description</label>
                    <textarea
                        v-model="editFormData.description"
                        id="edit-employment-type-description"
                        placeholder="Enter Description"
                        class="form-control"
                        rows="3"
                        spellcheck="false"
                    ></textarea>
                  </div>
                </div>
              </div>

              <!-- Error Alert -->
              <div v-if="modalError" class="alert alert-danger" role="alert">
                <i class="mdi mdi-alert-circle-outline me-2"></i>
                {{ modalError }}
              </div>

              <!-- Success Alert -->
              <div v-if="modalSuccess" class="alert alert-success" role="alert">
                <i class="mdi mdi-check-circle-outline me-2"></i>
                {{ modalSuccess }}
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button
                    type="submit"
                    @click="updateEmploymentType"
                    :disabled="processing"
                    class="btn btn-primary waves-effect waves-light"
                >
                  <span v-if="processing" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ processing ? 'Updating...' : 'Save Changes' }}
                </button>
                <button
                    type="button"
                    @click="closeEditModal"
                    :disabled="processing"
                    class="btn btn-secondary waves-effect"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Deactivate Employment Type Modal -->
      <div v-if="showDeactivateModal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">Deactivate Employment Type</h4>
              <button type="button" class="btn-close" @click="closeDeactivateModal"></button>
            </div>
            <div class="modal-body">
              <p>Are you sure you want to deactivate the employment type <strong class="text-primary">{{ selectedEmploymentType?.employment_type_name }}</strong>?</p>
              <div class="row">
                <div class="col-12 mb-3">
                  <label for="deactivation-reason" class="form-label">Reason for Deactivation (Optional)</label>
                  <textarea
                      v-model="deactivationReason"
                      id="deactivation-reason"
                      placeholder="Provide reason for deactivation"
                      class="form-control"
                      rows="3"
                      spellcheck="false"
                  ></textarea>
                </div>
              </div>

              <!-- Error Alert -->
              <div v-if="modalError" class="alert alert-danger" role="alert">
                <i class="mdi mdi-alert-circle-outline me-2"></i>
                {{ modalError }}
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button
                    type="submit"
                    @click="confirmDeactivation"
                    :disabled="processing"
                    class="btn btn-danger waves-effect waves-light"
                >
                  <span v-if="processing" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ processing ? 'Processing...' : 'Confirm Deactivation' }}
                </button>
                <button
                    type="button"
                    @click="closeDeactivateModal"
                    :disabled="processing"
                    class="btn btn-secondary waves-effect"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Employment Type Details Modal -->
      <div v-if="showDetailsModal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">Employment Type Details</h4>
              <button type="button" class="btn-close" @click="closeDetailsModal"></button>
            </div>
            <div class="modal-body">
              <div v-if="detailsEmploymentType" class="row">
                <div class="col-12">
                  <h5 class="text-primary mb-3">{{ detailsEmploymentType.employment_type_name }}</h5>
                </div>

                <div class="col-md-6 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Abbreviation</label>
                    <p class="mb-0 fw-semibold">{{ detailsEmploymentType.abbreviation || 'N/A' }}</p>
                  </div>
                </div>

                <div class="col-md-6 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Status</label>
                    <p class="mb-0 fw-semibold">
                      <i :class="detailsEmploymentType.status === 'active' ? 'mdi mdi-circle text-success' : 'mdi mdi-circle text-danger'" class="me-1"></i>
                      {{ detailsEmploymentType.status === 'active' ? 'Active' : 'Inactive' }}
                    </p>
                  </div>
                </div>

                <div class="col-md-6 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Employee Count</label>
                    <p class="mb-0 fw-semibold">{{ detailsEmploymentType.employee_count || 0 }}</p>
                  </div>
                </div>

                <div class="col-md-6 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Employment Type ID</label>
                    <p class="mb-0 fw-semibold">#{{ detailsEmploymentType.employment_type_id }}</p>
                  </div>
                </div>

                <div class="col-12 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Description</label>
                    <p class="mb-0">{{ detailsEmploymentType.description || 'No description available' }}</p>
                  </div>
                </div>

                <div class="col-md-6 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Created Date</label>
                    <p class="mb-0">{{ formatDate(detailsEmploymentType.created_at) }}</p>
                  </div>
                </div>

                <div class="col-md-6 mb-3">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Last Updated</label>
                    <p class="mb-0">{{ formatDate(detailsEmploymentType.updated_at) }}</p>
                  </div>
                </div>

                <div class="col-12 mb-3" v-if="detailsEmploymentType.created_by_name">
                  <div class="p-3 border rounded bg-light">
                    <label class="text-muted text-uppercase small mb-1">Created By</label>
                    <p class="mb-0">{{ detailsEmploymentType.created_by_name }} {{ detailsEmploymentType.created_by_lastname }}</p>
                  </div>
                </div>
              </div>

              <!-- Loading State -->
              <div v-else class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <p class="mt-2">Loading details...</p>
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button
                    type="button"
                    @click="closeDetailsModal"
                    class="btn btn-secondary waves-effect"
                >
                  Close
                </button>
                <button
                    v-if="hasPermission('manage_employment_types')"
                    type="button"
                    @click="editFromDetails"
                    class="btn btn-primary waves-effect"
                >
                  <i class="mdi mdi-pencil me-1"></i> Edit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              © Hospital Management Information System
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                2024
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { authUrl, executeJson, getRight } from "@/api";

export default {
  name: "EmploymentTypes",
  components: { NavigationBar },
  data() {
    return {
      // Loading states
      loading: false,
      processing: false,
      error: null,

      // Alerts
      modalError: null,
      modalSuccess: null,

      // Data
      employmentTypes: [],
      total: 0,

      // Pagination
      currentPage: 1,
      limit: 10,

      // Filters
      filters: {
        searchTerm: '',
        status: '',
        startDate: '',
        endDate: ''
      },

      // Modals
      showCreateModal: false,
      showEditModal: false,
      showDeactivateModal: false,
      showDetailsModal: false,

      // Forms
      formData: {
        employmentTypeName: '',
        abbreviation: '',
        status: 'active',
        description: ''
      },

      editFormData: {
        employmentTypeId: null,
        employmentTypeName: '',
        abbreviation: '',
        status: '',
        description: ''
      },

      // Selected items
      selectedEmploymentType: null,
      detailsEmploymentType: null,
      deactivationReason: '',

      // Search debounce
      searchTimeout: null
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.total / this.limit);
    },

    displayedPages() {
      const pages = [];
      const maxPages = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxPages / 2));
      let end = Math.min(this.totalPages, start + maxPages - 1);

      if (end - start < maxPages - 1) {
        start = Math.max(1, end - maxPages + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },

    offset() {
      return (this.currentPage - 1) * this.limit;
    }
  },

  mounted() {
    this.fetchEmploymentTypes();
  },

  methods: {
    // Permission check
    hasPermission(permission) {
      return getRight(permission);
    },

    // Fetch employment types from API
    async fetchEmploymentTypes() {
      this.loading = true;
      this.error = null;

      try {
        const data = {
          function: "getEmploymentTypes",
          ...this.filters,
          limit: this.limit,
          offset: this.offset
        };

        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.employmentTypes = response.data.data.employmentTypes || [];
          this.total = response.data.data.total || 0;

          // Add processing state to each type
          this.employmentTypes = this.employmentTypes.map(type => ({
            ...type,
            isProcessing: false
          }));
        } else {
          this.error = response.data.message || 'Failed to fetch employment types';
        }
      } catch (error) {
        console.error('Error fetching employment types:', error);
        this.error = error.message || 'An error occurred while fetching employment types';
      } finally {
        this.loading = false;
      }
    },

    // Search with debounce
    debounceSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.fetchEmploymentTypes();
      }, 500);
    },

    // Pagination
    changePage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.fetchEmploymentTypes();
      }
    },

    // Show employment type details
    showEmploymentTypeDetails(type) {
      this.detailsEmploymentType = type;
      this.showDetailsModal = true;
    },

    // Edit from details modal
    editFromDetails() {
      if (this.detailsEmploymentType) {
        this.closeDetailsModal();
        this.editEmploymentType(this.detailsEmploymentType);
      }
    },

    // Create employment type
    async createEmploymentType() {
      // Validation
      if (!this.formData.employmentTypeName) {
        this.modalError = 'Employment type name is required';
        return;
      }

      this.processing = true;
      this.modalError = null;
      this.modalSuccess = null;

      try {
        const data = {
          function: "createEmploymentType",
          ...this.formData
        };

        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.modalSuccess = response.data.message || 'Employment type created successfully';

          // Reset form and refresh list
          setTimeout(() => {
            this.closeCreateModal();
            this.fetchEmploymentTypes();
          }, 1500);
        } else {
          this.modalError = response.data.message || 'Failed to create employment type';
        }
      } catch (error) {
        console.error('Error creating employment type:', error);
        this.modalError = error.message || 'An error occurred while creating employment type';
      } finally {
        this.processing = false;
      }
    },

    // Edit employment type
    editEmploymentType(type) {
      this.selectedEmploymentType = type;
      this.editFormData = {
        employmentTypeId: type.employment_type_id,
        employmentTypeName: type.employment_type_name,
        abbreviation: type.abbreviation || '',
        status: type.status,
        description: type.description || ''
      };
      this.showEditModal = true;
      this.modalError = null;
      this.modalSuccess = null;
    },

    // Update employment type
    async updateEmploymentType() {
      // Validation
      if (!this.editFormData.employmentTypeName) {
        this.modalError = 'Employment type name is required';
        return;
      }

      this.processing = true;
      this.modalError = null;
      this.modalSuccess = null;

      try {
        const data = {
          function: "updateEmploymentType",
          ...this.editFormData
        };

        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.modalSuccess = response.data.message || 'Employment type updated successfully';

          // Refresh list
          setTimeout(() => {
            this.closeEditModal();
            this.fetchEmploymentTypes();
          }, 1500);
        } else {
          this.modalError = response.data.message || 'Failed to update employment type';
        }
      } catch (error) {
        console.error('Error updating employment type:', error);
        this.modalError = error.message || 'An error occurred while updating employment type';
      } finally {
        this.processing = false;
      }
    },

    // Deactivate employment type
    deactivateEmploymentType(type) {
      this.selectedEmploymentType = type;
      this.deactivationReason = '';
      this.showDeactivateModal = true;
      this.modalError = null;
    },

    // Confirm deactivation
    async confirmDeactivation() {
      this.processing = true;
      this.modalError = null;

      try {
        const data = {
          function: "deactivateEmploymentType",
          employmentTypeId: this.selectedEmploymentType.employment_type_id,
          reason: this.deactivationReason
        };

        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.closeDeactivateModal();
          this.fetchEmploymentTypes();
        } else {
          this.modalError = response.data.message || 'Failed to deactivate employment type';
        }
      } catch (error) {
        console.error('Error deactivating employment type:', error);
        this.modalError = error.message || 'An error occurred while deactivating employment type';
      } finally {
        this.processing = false;
      }
    },

    // Activate employment type
    async activateEmploymentType(type) {
      // Set processing state for this specific type
      type.isProcessing = true;

      try {
        const data = {
          function: "updateEmploymentType",
          employmentTypeId: type.employment_type_id,
          status: 'active'
        };

        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          this.fetchEmploymentTypes();
        } else {
          alert(response.data.message || 'Failed to activate employment type');
        }
      } catch (error) {
        console.error('Error activating employment type:', error);
        alert(error.message || 'An error occurred while activating employment type');
      } finally {
        type.isProcessing = false;
      }
    },

    // Modal management
    closeCreateModal() {
      this.showCreateModal = false;
      this.formData = {
        employmentTypeName: '',
        abbreviation: '',
        status: 'active',
        description: ''
      };
      this.modalError = null;
      this.modalSuccess = null;
    },

    closeEditModal() {
      this.showEditModal = false;
      this.editFormData = {
        employmentTypeId: null,
        employmentTypeName: '',
        abbreviation: '',
        status: '',
        description: ''
      };
      this.modalError = null;
      this.modalSuccess = null;
    },

    closeDeactivateModal() {
      this.showDeactivateModal = false;
      this.selectedEmploymentType = null;
      this.deactivationReason = '';
      this.modalError = null;
    },

    closeDetailsModal() {
      this.showDetailsModal = false;
      this.detailsEmploymentType = null;
    },

    // Utility functions
    formatDate(dateString) {
      if (!dateString) return '-';

      const date = new Date(dateString);
      const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      };

      return date.toLocaleDateString('en-US', options);
    }
  }
};
</script>

<style scoped>
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.modal.show {
  display: block !important;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.pagination {
  margin-bottom: 0;
}

.pagination .page-item {
  cursor: pointer;
}

.pagination .page-item.disabled {
  cursor: not-allowed;
}

.pagination .page-item.active .page-link {
  background-color: #5b73e8;
  border-color: #5b73e8;
}

.search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

.table th {
  font-weight: 600;
  font-size: 0.8125rem;
}

.alert {
  margin-bottom: 1rem;
}

.text-right {
  text-align: right !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.text-muted {
  color: #6c757d !important;
}

.small {
  font-size: .875em;
}
</style>